import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild, OnDestroy} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

//shared libs
import {
    EntityService, ModalService, ToastService, SelectizeComponent} from '../../blocks';
import { AppCodeGroup, ControlsParams, PricingParms, UserSessionService} from '../../shared';

//services
import { ResidenceDegreeService } from './residence-degree.service';
import { ResidenceDegree } from './residence-degree';

import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs/Subject';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'residence-degree',
    templateUrl: './residence-degree.component.html',
    styleUrls: ['./residence-degree.component.css']
})

export class ResidenceDegreeComponent implements OnInit, OnDestroy {
    ResidenceDegreeForm: UntypedFormGroup;

    editResidenceDegree: ResidenceDegree = <ResidenceDegree>{};
    controlsParams: ControlsParams;
    @Input() residenceDegree: ResidenceDegree;
    residenceDegrees: ResidenceDegree[] = [];
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    _PricingParms = <PricingParms>{};
    @ViewChild('btnCtrl1', { static: true }) btnCtrl1: any;
    serial: number;
    constructor(
        private fb: UntypedFormBuilder,
        public translate: TranslateService,
        private _residenceDegreeService: ResidenceDegreeService,
        private _userSessionService: UserSessionService,
        private _entityService: EntityService,
        private _modalService: ModalService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _location: Location,
        private _toastService: ToastService) {

        this.controlsParams = new ControlsParams(3120, AppCodeGroup.Buttons, true);

    }

    onClicked(e: number): void {
        switch (e) {

            case 1: //save code
                if (this.ResidenceDegreeForm.valid == true) {
                    this.save();
                    break;
                } else {
                    this._toastService.activateMsg('UI31');
                    break;
                }
            //case 3:
            //    this.delete();
            //    break;
            default:
                this._goBack();

        }
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit() {
        this._userSessionService.setBtnCtrl(this.btnCtrl1);
        this.ResidenceDegreeForm = this.fb.group({
                            
            degreeNameAr: ['', [<any>Validators.required]],
            degreeNameEn: ['', [<any>Validators.required]],
            cashDegGlChartAccountCode: ['', [<any>Validators.required]],
        creditDegreeGlChartAccountCode :'',
        compDegreeGlChartAccountCode   :'',
        cashMedGlChartAccountCode: ['', [<any>Validators.required]],
        creditMedGlChartAccountCode    :'',
        compMedGlChartAccountCode      :'',
        resType: ['', [<any>Validators.required]],
        limitByHour         :'',
        limitType: ['', [<any>Validators.required]],
        limitCost           :'',
        resBillItemCode: ['', [<any>Validators.required]],
        followUpBillItemCode    :'',
        sterilizeBillItemCode   :'',
        medFollowUpBillItemCode :'',
        bedCompanionBillItemCode:'',
        companionBillItemCode   : ''
        });                 


        this.getResidenceDegree();
    }

     getResidenceDegree() {

        let id = +this._route.snapshot.params['id'];
        if (this.isAddMode()) {
            this.editResidenceDegree = this._entityService.clone(this.residenceDegree);
            return;
        }
        else {
            this._residenceDegreeService.getResidenceDegree(id)
               .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(residenceDegree => this._setEditResidenceDegree(residenceDegree.data[0]),
                error => console.log(error),
                () => {
                    this.ResidenceDegreeForm.patchValue(this.editResidenceDegree);
                }
                );
        }

    }


     save() {
         if (this.editResidenceDegree.serial == null) {
         this.editResidenceDegree = this.ResidenceDegreeForm.value;
             this.editResidenceDegree.serial = 0;
             this._residenceDegreeService.addResidenceDegree(this.editResidenceDegree)
                .pipe(takeUntil(this.ngUnsubscribe))
                 .subscribe(c => {
                     if (c["returnFlag"]) {
                         this._goBack();
                     }
                 });
         }
         else {
             this.serial = this.editResidenceDegree.serial;
             this.editResidenceDegree = this.ResidenceDegreeForm.value;
             this.editResidenceDegree.serial = this.serial;
             this._residenceDegreeService.updateResidenceDegree(this.editResidenceDegree)
                .pipe(takeUntil(this.ngUnsubscribe))
                 .subscribe(c => {
                     if (c["returnFlag"]) {
                         this._goBack();
                     }
                 });
         }
     }

    private _setEditResidenceDegree(residenceDegree: ResidenceDegree) {
        if (residenceDegree) {
            this.residenceDegree = residenceDegree;
            this.editResidenceDegree = this._entityService.clone(this.residenceDegree);
            this.ResidenceDegreeForm.patchValue(residenceDegree);
        }
    }

    isAddMode() {
        let id = +this._route.snapshot.params['id'];
        return isNaN(id) || id == null;
    }

    _goBack(): void {
        this._location.back();
    }

}

